/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.32/esri/copyright.txt for details.
*/
function t(t){throw new Error("Not yet implemented")}const e=!1;export{t as execute,e as isAsync};
